import { render, staticRenderFns } from "./MessagePopup.vue?vue&type=template&id=295011b8&scoped=true"
import script from "./MessagePopup.vue?vue&type=script&lang=ts"
export * from "./MessagePopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295011b8",
  null
  
)

export default component.exports